<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-alert" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.7606 28.0156L18.4369 6.67045C18.0946 6.07753 17.2388 6.07753 16.8965 6.67045L4.57288 28.0156C4.23055 28.6085 4.65846 29.3497 5.3431 29.3497H29.9903C30.675 29.3497 31.1029 28.6085 30.7606 28.0156ZM20.7476 5.33638C19.3783 2.9647 15.9551 2.9647 14.5858 5.33638L2.2622 26.6815C0.892908 29.0532 2.60452 32.0178 5.3431 32.0178H29.9903C32.7289 32.0178 34.4405 29.0532 33.0712 26.6815L20.7476 5.33638ZM17.6656 11.1171C18.4024 11.1171 18.9997 11.7144 18.9997 12.4512V20.4556C18.9997 21.1924 18.4024 21.7897 17.6656 21.7897C16.9288 21.7897 16.3315 21.1924 16.3315 20.4556V12.4512C16.3315 11.7144 16.9288 11.1171 17.6656 11.1171ZM17.6654 26.6817C18.6478 26.6817 19.4441 25.8854 19.4441 24.903C19.4441 23.9206 18.6478 23.1242 17.6654 23.1242C16.683 23.1242 15.8866 23.9206 15.8866 24.903C15.8866 25.8854 16.683 26.6817 17.6654 26.6817Z"
      fill="currentColor"
    />
  </BaseSvg>
</template>
